// NOTE: some of the following keys is used in STATE_ID_TO_VIEW_NAME defined in OtherKeys.js file
export const PERSISTENCE_STATE_KEYS = {
  planResourceGridView: "b-plans-view-resources-state",
  remindersView: "b-reminders-view-state-v3",
  checklistView: "b-checklist-view-state-v2",
  boardSetting: "b-settings-board",
  boardSettingTeamGrid: "b-settings-tab-team-grid",
  boardSettingIncentiveTagCategoryGrid: "b-settings-tab-incentive-tag-category-grid",
  boardSettingIncentiveTagsGrid: "b-settings-tab-incentive-tags-grid",
  taskEditorResourceTab: "b-task-editor-resource-tab",
  taskEditorPlansTab: "b-task-editor-plans-tab",
  globalSearch: "b-global-search",
  viewManagementEditorGrid: "b-view-management-editor-grid",
  lastSelectedBoardKey: "last-selected-view-state-on-board-v2",
  settingUserTab: "b-settings-user-tab-grid",
  taskStatusHistoryTab: "b-task-status-history-tab-v1",
  userEditor: "b-user-editor-state",
  taskBudgetGrid: "b-task-budget-grid",
  importEditor:"b-import-editor",
  timelineOptionsGrid: "b-timeline-options-grid",
  timelineNonWorkingDaysGrid: "b-timeline-non-working-days-grid",
  clientChecklistGrid: "b-client-checklist-grid-v3",
  allowedEmailNotifications: "AllowedNotifications",
  budgetMappedFieldsKey: "user-mapped-budget-fields-v2",
  clientEditorContactGridState: "b-client-editor-contact-grid-state",
  userEditorContactGridState: "b-user-editor-contact-grid-state",
  contactNestedGridState: "b-contact-nested-grid-state",
  viewSelectedId: "view:view-selected-id",
  entityFinderEditor: "b-entity-finder-editor-state",
  taskFinderEditor: "b-task-finder-editor-state",
  timelineConfiguratorEditor: "b-timeline-configurator-editor-v1",
  timelineConfiguratorEditorTimescaleGridState: "b-timeline-configurator-editor-timescale-grid-state",
  timelineConfiguratorEditorNonWorkingDaysGridState: "b-timeline-configurator-editor-non-working-days-grid-state",
  timelineConfiguratorEditorSettingsGridState: "b-timeline-configurator-editor-settings-grid-state",
  checklistItemGrid: "checklist-item-grid-v1",
  viewOrganizerEditor: "b-view-organizer-editor-v1",
  shareViewsEditor: "b-share-views-editor-v1",
  viewFolderEditorGrid: "b-view-folder-editor-grid",
  boardAlertsEditor: "b-board-alerts-editor-v1",
  userDefaultEditPermission: "default-edit-permission",
  userDefaultViewPermission: "default-view-permission",
  budgetHoverOrder: "b-budget-hover-order-v2",
  budgetLabel: "b-budget-label-v2",
  budgetActualDays: "b-budget-actual-days",
  selectedRowHighlight: "b-selected-row-highlight",
  hoverGridCellHighlight: "b-hover-grid-cell-highlight",
  hoverTaskEventHighlight: "b-hover-task-event-highlight",
  resourceIconSize: "resource-icon-size",
  taskAutoArchiveEnabled: "is-task-auto-archive-enabled",
  taskAutoArchiveDays: "task-auto-archive-days",
  taskAutoArchiveStatusFilter: "task-auto-archive-statuses",
  mySwivuGrid: "b-myswivupage-view-2",
  enableRedundantTaskEvents: "b-enable-redundant-task-events",
  disableTimelineZoomOnMouse: "b-disable-timeline-zoomOnMouse",
  redistributeSubGridPanels: "b-redistribute-subGrid-panels",
  centerSchedulerLineOnToday: "b-center-scheduler-line-on-today",
  viewStatePIITS: "view-state-piits",
  viewInspectorEditor: "b-views-inpector-editor-v1",
  swivuAssistSheetUrl: "swivuAssistSheetUrl",
  swivuAssistLastUpdated: "swivuAssistLastUpdated",
  lastAwardTagId: "lastAwardTagId",
  personalSettingAlertsGridState: "b-personal-setting-alerts-grid-state",
  taskBudgetFocusMode: "task-budget-focus-mode",
  lastVisitedViews: "last_visited_views",
  timelineFiltersState: "timeline-filters-state-v2",
  draftContextPromptSiteSafety: "draft-context-prompt-site-safety",
  draftContextPromptWorkmanship: "draft-context-prompt-workmanship",
  draftFieldAdvisorPromptAnalyze: "draft-field-advisor-prompt-analyze",
  draftFieldAdvisorPromptExecute: "draft-field-advisor-prompt-execute",
  draftFieldAdvisorPromptReview: "draft-field-advisor-prompt-review",
  isPublishContextPromptSiteSafety: "is-publish-context-prompt-site-safety",
  isPublishContextPromptWorkmanship: "is-publish-context-prompt-workmanship",
  isPublishFieldAdvisorPromptAnalyze: "is-publish-field-advisor-prompt-analyze",
  isPublishFieldAdvisorPromptExecute: "is-publish-field-advisor-prompt-execute",
  isPublishFieldAdvisorPromptReview: "is-publish-field-advisor-prompt-review",
  openAiApiKey: "open-ai-api-key",
  hasOpenAiApiKey: "has-open-ai-api-key",
  taskFilesEditor: "b-task-files-editor",


  descriptionZoomState: "description-zoom-state-v1",
  draftPromotePrompt: "draft-promote-prompt",
  isPublishPromotePrompt: "is-publish-promote-prompt",
  dashboardConfig: "dashboard-config-v1",
  warRoomSizing: "war-room-sizing",
}
